//
// This js file is used to controll all the client side actions for documentation feature.
//

$(document).ready(function () {
    $("code").addClass("prettyprint");
    run_prettify();

    //
    // This function controls the displaying or hiding the TOC in the mobile display solution.
    //
    $("#toggleLeftPanel").click(function (e) {
        $("#docMenu").toggle();
        $("#toggleLeftPanel").toggleClass("ms-Icon--ChevronRight ms-Icon--ChevronLeft");
    });

    //
    // Use keyboard enter key on mobile view TOC carot.
    //
    $("#toggleLeftPanelContainer").keypress(function (e) {
        if (e.which == 13) {
            $("#toggleLeftPanel").click();
        }
    })

    //
    // Handle the logic for click one TOC which does not have href value.
    //
    $("#docNavMenu span").click(function (e) {
        expandMenu(this);
    });

    //
    // Use keyboard enter key on carot will collapse/uncollpase the current level of TOC.
    //
    $("#docNavMenu span").keypress(function (e) {
        if (e.which == 13) {
            expandMenu(this);
        }
    });

    //
    // Set the cookie when user click the toc item to remeber the current toc layer.
    //
    $("#docNavMenu a").click(function (e) {
        var currentTocStructure = $(this).attr("data-stru");
        var date = new Date();
        var millisecondForOneDay = 24 * 60 * 60 * 1000;
        date.setTime(date.getTime() + millisecondForOneDay);
        var newCookie = "CurrentTocStructure=" + currentTocStructure + ";expires=" + date.toUTCString + ";path=/";
        document.cookie = newCookie;
    });

    updateGitHubInfoDiv();

    //Scroll TOC's first active element into view without scrolling the document as well
    if ($("li>a.active")[0]) {
        $("li>a.active")[0].scrollIntoView(false);
    }
});


//
// When scrolling the window, make the "TOC" and "InThisArticle" panel stick with the current window.
//
$(window).scroll(function (e) {

    if ($("#toggleLeftPanelContainer").css("display") == "none") {
        // first scroll then fix
        if ($(window).scrollTop() > $("#docContent").offset().top) { //was 50
            $("#docNavMenu").addClass("dxp-navScroll");
            $("#docNavMenu").removeClass("dxp-noNavScroll");
            $("#sidebarcontrol").addClass("dxp-navScroll");
            $("#sidebarcontrol").removeClass("dxp-noNavScroll");
        }
        else {
            $("#docNavMenu").removeClass("dxp-navScroll");
            $("#docNavMenu").addClass("dxp-noNavScroll");
            $("#sidebarcontrol").removeClass("dxp-navScroll");
            $("#sidebarcontrol").addClass("dxp-noNavScroll");
        }

        setTocHeight();
    }

    if ($(".dxp-bs-docs-sidebar").css("display") != "none") {
        setInThisArticleStatus();
    }

});

//
// When the window is resized, have to adjust display width for all panels.
//
$(window).bind('resize', function () {
    adjustDisplayWidth();
});

//
// Adjust the display width for all panels.
//
function adjustDisplayWidth() {
    var widthForSidePanel = 250;
    var leftPanelLeftAndRightMargin = 20;
    var centerPanelLeftAndRightMargin = 20;
    var minWidthForWideWindow = 750;
    var maxWidthForMobileWindow = 600;
    if ($("#documentationFrame") != null) {
        var containerWidth = $("#documentationFrame").width();
        //Calculate the doc content width if have both left panel(Toc) and right panel(in this article)
        var docContentWidth = containerWidth - 2 * widthForSidePanel - leftPanelLeftAndRightMargin - centerPanelLeftAndRightMargin;

        //Wide window.
        if (docContentWidth >= minWidthForWideWindow) {
            $("#docContent").width(docContentWidth);
            $("#docContent").removeClass("dxp-narrowDocContent");
            $("#docContent").addClass("dxp-wideDocContent");
            $("#docNavMenu").css("overflow-y", "auto");
            $("#docNavMenu").removeClass("dxp-relative");
            $("#docNavMenu").width(widthForSidePanel);
            $(".dxp-bs-docs-sidebar").css({ "display": "block" });
            $("#toggleLeftPanelContainer").css({ "display": "none" });
            if (!$("#docMenu").is(':visible')) {
                $("#docMenu").css({ "display": "block" });
            }
            setTocHeight();
        }

            //Mid-width window, hide "In This Article", only have left panel(Toc) and center panel(Content)
        else if (docContentWidth >= maxWidthForMobileWindow && docContentWidth < minWidthForWideWindow) {
            $(".dxp-bs-docs-sidebar").css({ "display": "none" });
            $("#docContent").width(containerWidth - widthForSidePanel - leftPanelLeftAndRightMargin - centerPanelLeftAndRightMargin);
            $("#docContent").removeClass("dxp-narrowDocContent");
            $("#docContent").addClass("dxp-wideDocContent");
            $("#docNavMenu").css("overflow-y", "auto");
            $("#docNavMenu").removeClass("dxp-relative");
            $("#docNavMenu").width(widthForSidePanel);
            $("#toggleLeftPanelContainer").css({ "display": "none" });
            if (!$("#docMenu").is(':visible')) {
                $("#docMenu").css({ "display": "block" });
            }
            setTocHeight();
        }

            //Samll window, hide "In This Article", and place both Toc and Content inside the center panel.
        else {
            $(".dxp-bs-docs-sidebar").css({ "display": "none" });
            $("#docContent").addClass("dxp-narrowDocContent");
            $("#docContent").removeClass("dxp-wideDocContent");
            $("#docNavMenu").width(containerWidth);
            $("#docContent").width(containerWidth);
            $("#docNavMenu").css({ "margin-top": "5px", "height": "auto", "overflow-y": "visible" });
            $("#docNavMenu").addClass("dxp-relative");
            $("#docMenu").css({ "display": "none" });
            $("#toggleLeftPanelContainer").css("display", "block");
        }

        //After adjusting everything based on width, set TOC and In This Article scrolling styles based on distance from top of page
        if ($(window).scrollTop() > $("#docContent").offset().top) {
            $("#docNavMenu").addClass("dxp-navScroll");
            $("#docNavMenu").removeClass("dxp-noNavScroll");
            $("#sidebarcontrol").addClass("dxp-navScroll");
            $("#sidebarcontrol").removeClass("dxp-noNavScroll");
        }
        else {
            $("#docNavMenu").removeClass("dxp-navScroll");
            $("#docNavMenu").addClass("dxp-noNavScroll");
            $("#sidebarcontrol").removeClass("dxp-navScroll");
            $("#sidebarcontrol").addClass("dxp-noNavScroll");
        }
    }
}

//
// Set the "InThisArticle" control active status.
//
function setInThisArticleStatus() {
    var currentPosition = $(this).scrollTop();
    $("#inThisArticle li").removeClass("active");
    $("#docContent h2").each(function () {
        var currentH2Position = $(this).offset().top;
        if (currentPosition <= currentH2Position) {
            var inThisArticleLinkId = "#iTA" + this.id;
            $(inThisArticleLinkId).addClass("active");
            return false;
        }
    });
}

//
// Expand or collapse the TOC.
//
function expandMenu(aElement) {
    var ulItem = $(aElement).attr("data-target");
    if (ulItem != null && ulItem != "") {
        $(ulItem).toggleClass("dxp-in");
        $(aElement).toggleClass("ms-Icon--ChevronRight ms-Icon--ChevronDown");

    }

    // differentiate the mobile view toggleLeftPanel chevron with the rest chevron in the TOC
    if ($(aElement)[0].id !== 'toggleLeftPanel') {
        if ($(aElement)[0].classList.contains("ms-Icon--ChevronDown")) {
            $(aElement)[0].setAttribute("aria-label", $(aElement)[0].getAttribute("aria-label").replace("Collapsed", "Expanded"));
        } else if ($(aElement)[0].classList.contains("ms-Icon--ChevronRight")) {
            $(aElement)[0].setAttribute("aria-label", $(aElement)[0].getAttribute("aria-label").replace("Expanded", "Collapsed"));
        }
    }
}

//
// Move the GitHubInfo div to right after doc header.
//
function updateGitHubInfoDiv() {
    $("#GitHubInfo").detach().appendTo("#body h1");
    $("#GitHubInfo").css("margin-top", "5px");
    $("#GitHubInfo").css("display", "block");
}

//
// Set the doc toc height
//
function setTocHeight() {
    var tocMarginTopAndBottom = 20;
    var frontDoorHeaderHeight = $("#docContent").offset().top;
    var frontDoorFooterHeight = 196; // default footer height
    if ($("#footerWrapper").length > 0) {
        frontDoorFooterHeight = $("#footerWrapper").height();
    }
    var height = $(window).height() - tocMarginTopAndBottom;

    //Set the min-height for the doc content panel.
    var minHeight = height - frontDoorHeaderHeight - frontDoorFooterHeight;
    $("#docContent").css("min-height", minHeight);

    var scrollTop = $(window).scrollTop();
    var frontDoorHeaderToTop = frontDoorHeaderHeight - scrollTop;
    if (frontDoorHeaderToTop > 0) {
        height = height - frontDoorHeaderToTop;
    }

    if ($("#footerWrapper").length > 0) {
        var frontDoorFooterToBottom = $(window).height() + $(window).scrollTop() - $("#footerWrapper").offset().top;
        if (frontDoorFooterToBottom > 0) {
            height = height - frontDoorFooterToBottom;
        }
    }
    else if ($("#docContent").height() - $(window).height() - $(window).scrollTop() <= 0) {
        height = height - frontDoorFooterHeight;
    }

    if (height == minHeight)
    {
        height = minHeight - tocMarginTopAndBottom;
    }

    $("#docNavMenu").css("height", height);
    $("#sidebarcontrol").css("height", height);
}

//
// Set the toc item "expand" and "active" status
//
function setTocStatus() {
    var currentDocPath = getCurrentDocPath();
    //lastClickTocInCookie will store the parents ul ids and doc url, like: |45|46|api-reference/v1.0/api/user_list_contacts
    var lastClickTocInCookie = readCookie("CurrentTocStructure");
    var currentSelectedElements;
    //This will check where last click url is current requested url
    if (lastClickTocInCookie != null && lastClickTocInCookie.indexOf(currentDocPath, lastClickTocInCookie.length - currentDocPath.length) != -1) {
        currentSelectedElements = $('a[data-stru="' + lastClickTocInCookie + '"]');
    }
    else {
        //Since different doc items may have the same url, so we may have multiple current selected elements
        currentSelectedElements = $('a[href="' + window.location.pathname.toLowerCase() + '"]');
    }

    currentSelectedElements.each(function () {
        $(this).addClass("active");
        var tocItemStructure = $(this).attr("data-stru");
        if (tocItemStructure == null) {
            return;
        }
        var parents = tocItemStructure.split("|");
        for (i = 1; i < parents.length - 1; i++) {
            var parentId = "#item" + parents[i];

            $(parentId).addClass("dxp-in");
            var relatedSpanElement = $('span[data-target="' + parentId + '"]');
            relatedSpanElement.removeClass("ms-Icon--ChevronRight");
            relatedSpanElement.addClass("ms-Icon--ChevronDown");
            relatedSpanElement[0].setAttribute("aria-label", relatedSpanElement[0].getAttribute("aria-label").replace("Collapsed", "Expanded"));
        }
    });
}

//
// Get the current doc path
//
function getCurrentDocPath() {
    var docPagePrefix = "/graph/docs/";
    var fullPagePath = window.location.pathname.toLowerCase();
    var docPathStart = fullPagePath.indexOf(docPagePrefix) + docPagePrefix.length;
    return fullPagePath.substring(docPathStart, fullPagePath.length);
}

//
// Read cookie
//
function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}